import { format } from "date-fns";
import { styled } from "styled-components";
import { Typography } from "components/typography";

import { Icon } from "@mindlercare/ui-web";
import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";
import Tooltip from "@mui/material/Tooltip";
import { withStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

interface Props {
  assignedAt: Date;
  assignedBy: string;
  sortKey?: string | number;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const AssignedCellWithIcon = ({ assignedAt, assignedBy }: Props) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Icon.Send width={20} color={defaultTheme.COLORS.GRAY} />

      <AssignedByTooltip
        title={t("ASSIGNED_BY_X", {
          name: assignedBy,
        })}
      >
        {/* div required to show tooltip, wtf */}
        <div>
          <Typography variant="body-small" color="GRAY_BLACK">
            {format(assignedAt, "yyyy-MM-dd")}
          </Typography>
        </div>
      </AssignedByTooltip>
    </Wrapper>
  );
};

const AssignedByTooltip = withStyles({
  tooltip: {
    background: "rgba(85, 79, 77, 1)",
    fontSize: "0.75rem",
  },
})(Tooltip);
